var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistrainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 12.052,
    cy: 22.027,
    r: 1.589,
    transform: "rotate(-60.143 12.052 22.026)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M15.323 17.893a11.87 11.87 0 017.599-2.768c6.58-.016 11.931 5.308 11.948 11.888s-5.308 11.931-11.888 11.948c-6.458.016-11.733-5.111-11.937-11.521"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M20.174 10.33h5.573c.663 0 1.202.538 1.202 1.202v3.594h-7.976v-3.594c0-.663.538-1.202 1.202-1.202zM22.961 9.228c-.207-.927-.229-3.371-2.284-4.63-1.886-1.155-4.066-.925-5.769.622"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M25.126 22.222c-5.974-1.731-5.974 4.528-2.204 4.444 3.693-.082 4.155 5.894-2.413 4.074M22.778 20.893v.547M22.778 31.564v.546M9.749 6.35l-2.76-.691.638 2.773-1.978 2.044 2.72.834.782 2.735 2.082-1.939 2.76.691-.639-2.772 1.979-2.045-2.721-.833-.781-2.736L9.749 6.35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistrainment);
export default __webpack_public_path__ + "static/media/distrainment.decf45f7365ea3c32497fb1dca9aac2a.svg";
export { ForwardRef as ReactComponent };